<template>
  <div class="custom-select">
    <div
      :class="{ 'disabled-select': formConfig.type === 'view' }"
      class="cost-select el-textarea el-input--small"
      style="min-height: 32px"
      @click="openModal"
    >
      <el-tag
        v-for="(item, index) in value"
        :key="index"
        closable
        @close="handleClose(item)"
        >{{ item.businessName }}</el-tag
      >
    </div>
    <!-- 弹框 -->
    <SelectConfig ref="selectConfig" @onGetSelect="onGetSelect" />
  </div>
</template>

<script>
import SelectConfig from '@/found/components/select_org_cus_ter/select_config.vue';

export default {
  name: 'OrgList',
  props: {
    autosize: Object,
    title: String,
    value: Array,
    disabled: Boolean,
    getValue: Function,
    params: {
      type: Object,
      default: () => ({}),
    },
    formConfig: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },
  components: {
    SelectConfig,
  },
  created() {},
  methods: {
    // 新增弹窗
    openModal() {
      if (this.disabled || Object.keys(this.params).length === 0) {
        return;
      }
      const {
        idKey, nameKey, parentField, parentParamKey, parentJoin, parentTip,
      } = this.params;
      // 已选数据还原成原始键结构，供弹窗回显勾选
      const data = (this.value || []).map((v) => ({
        [idKey]: v.businessCode,
        [nameKey]: v.businessName,
      }));
      const params = {
        ...this.params,
        data,
        // 以弹窗内实际勾选为准，避免取消的行被回显数据合并回来重复选中
        noReset: true,
      };
      // 需要先选上级（如细类依赖大类、预算科目依赖费用层级），并把上级编码传参
      if (parentField) {
        const parentList = (this.getValue && this.getValue(parentField)) || [];
        if (!parentList.length) {
          this.$message.warning(parentTip || '请先选择大类');
          return;
        }
        const codes = parentList.map((p) => p.businessCode);
        params.paramData = {
          ...(this.params.paramData || {}),
          [parentParamKey || 'categoriesCodeList']: parentJoin ? codes.join(',') : codes,
        };
      }
      this.$refs.selectConfig.openSelectModal(params);
    },
    // 选择回调：统一转成 businessCode/businessName
    onGetSelect(val) {
      const { idKey, nameKey } = this.params;
      const list = (val || []).map((m) => ({
        businessCode: m[idKey],
        businessName: m[nameKey],
      }));
      this.$emit('input', list);
      this.$emit('change', list);
    },
    // 清除选择
    clearFn(e) {
      e.stopPropagation();
      this.$emit('change');
    },
    handleClose(item) {
      if (this.disabled) {
        return;
      }
      const data = this.value.filter(
        (v) => v.businessCode !== item.businessCode,
      );
      this.$emit('input', data);
      this.$emit('change', data);
    },
  },
};
</script>

<style lang="less" scoped>
.cost-select {
  position: relative;
  border: 1px solid #dddfe6;
  border-radius: 5px;
  padding: 5px;

  /deep/ .el-input__inner {
    padding-right: 30px;
  }

  .clear-icon {
    width: 25px;
    height: 100%;
    position: absolute;
    right: 5px;
    top: 0;
    text-align: center;
    color: #c0c4cc;
    transition: all 0.3s;
    padding-top: 1px;
    display: none;

    .el-icon-circle-close {
      width: 100%;
      font-size: 14px;
      cursor: pointer;
      transition: color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    }
  }

  &:hover {
    .clear-icon {
      display: block;
    }
  }
}

.disabled-select {
  pointer-events: none;
  background: #f5f7fa;
}
</style>
